
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-guide-custom-ui-demo-custom-ui"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custom-ui.md?type=demo')
};